import { AbsDatiUtente } from "./AbsDatiUtente"

export class DatiUtente extends AbsDatiUtente{

    
}